import { getClientInfo } from './utils';
import { utils } from '@alife/cone-arms-core';

const { checkWin } = utils;

export const fixIosPerformanceObserveBug = () => {
  const { os, os_version } = getClientInfo();
  const needFix =
    os?.toLowerCase() === 'ios' && os_version && Number(os_version.split('.')[0]) < 14;
  // @link https://bugs.webkit.org/show_bug.cgi?id=209216
  if (
    checkWin() &&
    needFix &&
    typeof PerformanceObserver === 'function' &&
    Array.isArray(PerformanceObserver.supportedEntryTypes) &&
    // @ts-ignore 检测添加的标记
    !PerformanceObserver.prototype.observe.hasFix
  ) {
    const originObserve = PerformanceObserver.prototype.observe;
    PerformanceObserver.prototype.observe = function (options) {
      if (options && !Array.isArray(options.entryTypes) && options.type) {
        const entryTypes = [options.type];
        return originObserve.call(this, { entryTypes });
      }
      return originObserve.call(this, options);
    };
    // @ts-ignore 添加标记避免重复覆盖
    PerformanceObserver.prototype.observe.hasFix = true;
  }
};
